export const Table = {
  parts: ['table', 'td'],
  baseStyle: {
    cellSpacing: '10px',
    borderSpacing: '10px',
  },
};
